<nz-row>
  <nz-card   style="width:300px;margin-top: 10px;" nzTitle="Cài đặt thời gian" >
    <div class="config_time">
      <div class="field-row">
        <label nz-checkbox [(ngModel)]="this.data_object.data.display_object" (ngModelChange)="update(this.data_object.data)">Ẩn đếm ngược khi hết thời gian</label>
        </div>
        <div class="field-row">
          <label nz-checkbox [(ngModel)]="data_object.data.display_now" [disabled]="this.data_object.data.disabled" (ngModelChange)="update(this.data_object.data)">Ẩn trước khi đến thời gian bắt đầu</label>
          </div>
      <div class="config_day">
        <p class="title">Thời gian bắt đầu đếm ngược: </p>
        <input style=" margin: 0.4rem 0;width: 100%;font: initial;" [value]="dateStart" type="datetime-local" (blur)="CheckDayInput($event.target['value'])">
      </div>

      
      <div class="config_day">
        <p class="title">Thời gian kết thúc đếm ngược: </p>
        <input style=" margin: 0.4rem 0;width: 100%;font: initial;" [value]="dateEnd" type="datetime-local"  (blur)="CheckDayEnd($event.target['value'])">
      </div>
    
    </div>
    <div class="button">
      <button nz-button nzBlock nzType="default" [disabled]="this.checkTimeIsCorrect" (click)="SetTime()">CẬP NHẬT</button>
    </div>
  </nz-card>
  
 
</nz-row>